import { getCountryCode } from './cookieconsent/models/Legal';
import options from './cookieconsent/options/location';
import { IpInfo, makeAxiosRequest } from './cookieconsent/utils';

export const getService = () => {
  const serviceOption = options.services[0];
  return options.serviceDefinitions[serviceOption]();
};

// requires a `service` object that defines at least a `url` and `callback`
export const runService = async (service): Promise<IpInfo> => {
  // const isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;

  // if (isOperaMini) {
  //   return;
  // }

  return await makeAxiosRequest(service.url, service.headers);
};

export const getGeoIpCountryCode = async (): Promise<string | undefined> => {
  const service = getService();
  const location = await runService(service);

  return location?.country;
};

const geoIpLookup = async (): Promise<boolean> => {
  const countryCode = await getGeoIpCountryCode();

  return getCountryCode(countryCode).hasLaw;
};

export default geoIpLookup;
